import { useDispatch } from "react-redux";
import { useAppSelector } from "../../../../../store/reduxHooks";
import {
  TEditApplicationBank,
  useEditApplicationBankMutation,
} from "../../../../../store/api/application.api";
import { IValueEditExternalBank } from "../../../../../interfaces/Application/BankCredit/IExternalBankChangeStatusForm";
import { CHANGE_EXTERNAL_ACTIVE_BANK_INFO } from "../../../../../store/slice/requestAppSlise/requestAppSlise";

export const useChangeApplicationStatus = () => {
  const activeBankInfo = useAppSelector(
    (state) => state.requestAppSlise.data.bank,
  );

  const dispatch = useDispatch();

  const bankId = activeBankInfo.bank_id;
  const applicationId = activeBankInfo.application_id;

  const [editBank, { isLoading: isLoadingEditBank }] =
    useEditApplicationBankMutation();

  const handleSubmitForm = async (value: IValueEditExternalBank) => {
    const formData: TEditApplicationBank = {
      bank_id: bankId,
      app_id: applicationId,
      status_id: value.status_id,
      platform_app_id: value.platform_app_id
    };

    try {
      const result = await editBank(formData).unwrap();

      dispatch(CHANGE_EXTERNAL_ACTIVE_BANK_INFO(result.data.status));
    } catch {}
  };

  return { handleSubmitForm, isLoadingEditBank };
};
